import React from "react"
import ReactDOM from "react-dom";
import { fetchBigCommerceApi, HTTP_METHOD } from "utils/bigCommerceAuth";
import _ from 'lodash';
import Slider from "react-slick";
// import "slick-carousel/slick/slick.css"; 
// import "slick-carousel/slick/slick-theme.css";

interface Slide {
    url: string;
    isVideo?: boolean;
}

interface Props {
    slides: Slide[];
}



const ProductSlideShow = (props: Props) => {

    const settingsDesktop = {
        customPaging: function(i: number) {
            return (
                <a>
                    <img src={props.slides[i].url}/>
                </a>
            )
        },
        dots: true,
        dotsClass: "slick-dots slick-thumb",
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1
    }

    const settingsMobile = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 1.2,
        slidesToScroll: 1,
        swipeToSlide: true,
        responsive: [
            {
                breakpoint: 350,
                settings: {
                  slidesToShow: 1.1,
                  slidesToScroll: 1,
                }
            }
        ]
    }
    return (
        <div className="product-slide-show">
            <Slider {...settingsDesktop} className="product-slide-show__slick-desktop">
                {
                    props.slides.map((slide: Slide) => 
                        <div className="product-side-show__img-container">
                            <img src={slide.url}/>
                        </div>
                    )
                }
            </Slider>
            <Slider {...settingsMobile} className="product-slide-show__slick-mobile">
                {
                    props.slides.map((slide: Slide) => 
                        <div className="product-side-show__img-container">
                            <img src={slide.url}/>
                        </div>
                    )
                }
            </Slider>
        </div>
    )
}

const getResources = async (sku: string) => {
    // get images and videos from bigC
    const resources = await fetchBigCommerceApi(HTTP_METHOD.POST, new Headers(), {
        query: `query fetchProductImagesBySku($sku: String) {
            site {
            product(sku: $sku) {
                defaultImage {
                ...ImageFields
                }
                images {
                edges {
                    node {
                    ...ImageFields
                    }
                }
                }
            }
            }
        }
        
        fragment ImageFields on Image {
            url320wide: url(width: 320)
            url460wide: url(width: 460)
            url660wide: url(width: 660)
        }
        `,
        variables: {
            sku,
        }
    })
    return resources
}

const getSlides = async (sku: string) => {
    const response = await getResources(sku)
    const json = await response.json();
    let images: {
        defaultImage: boolean;
        images: {
            url320wide: string,
            url460wide: string,
            url660wide: string
        }
        isVideo: boolean;
        url: string;
    }[] = [];
    images = json.data.site?.product?.images.edges.map((node: { node: { [key: string]: string } }) => {
        return {
            images: node.node,
            url: node.node.url660wide,
            defaultImage: _.isEqual(node.node, json.data.site?.product.defaultImage),
            isVideo: false,
        }
    });
    return images
}

export default function render() {
    const elements = document.getElementsByClassName('slide-show-section');
    Array.prototype.map.call(elements, (element: HTMLElement) => {
        getSlides(element?.dataset?.sku || '').then((slides: Slide[]) => {
            if (slides) {
                return ReactDOM.render(<ProductSlideShow slides={slides} />, element);
            }
        })
    });
}
